import React, { useEffect, useState } from "react";
import { ClockIcon } from "lucide-react";
const START_SECONDS = 17 * 60 + 34; // 00:17:34

function format(n: number) {
  return n.toString().padStart(2, "0");
}
export function CountdownTimer() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = setInterval(() => {
      setSeconds(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor(seconds % 3600 / 60);
  const secs = seconds % 60;
  const units = [{
    label: "HORAS",
    value: format(hrs)
  }, {
    label: "MIN",
    value: format(mins)
  }, {
    label: "SEG",
    value: format(secs)
  }];
  return <div className="flex flex-col items-center gap-2" data-id="element-47" data-mp="15fqx82vrrqne">
      <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-red-600" data-id="element-48" data-mp="34pp84hvjuxug">
        <ClockIcon className="h-4 w-4" data-id="element-49" data-mp="2zsyue177wec7" />
        La oferta expira en
      </div>
      <div className="flex items-center gap-2" data-id="element-50" data-mp="1c0f8diyv2ox6">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-51" data-mp="1gzi4gdwv5kt0" data-mpi={i}>
            <div className="flex min-w-[58px] flex-col items-center rounded-xl bg-navy-800 px-2 py-2 text-white shadow-md" data-id="element-52" data-mp="1h0jecf258195">
              <span className="font-display text-2xl font-extrabold tabular-nums sm:text-3xl" data-id="element-53" data-mp="124lofeitbt5d">
                {u.value}
              </span>
              <span className="mt-0.5 text-[10px] font-semibold tracking-wider text-white/60" data-id="element-54" data-mp="1uqmx2w1tdctu">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className="font-display text-2xl font-extrabold text-navy-800" data-id="element-55" data-mp="1l1wmwwwmeijr">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}